import request from '../utils/fetch';

// 刷新token
export const tokenRefresh = async (params: { refreshToken: string }) => {
  return request('/account/v1/token:refresh', {
    tokenFree: true,
    method: 'POST',
    params: {
      t: Date.now(),
    },
    data: {
      ...params,
    },
  });
};

export const getTaskList = async (params: TaskListParamsType) => {
  return request('/transfer/v1/transferTask/page', {
    // tokenFree: true,
    method: 'POST',
    params: {
      t: Date.now(),
    },
    data: {
      ...params,
    },
  });
};

export const getResultByTaskId = async (taskId: string) => {
  return request(`/transfer/v1/task/${taskId}/result`, {
    // tokenFree: true,
    method: 'POST',
    params: {
      t: Date.now(),
    },
  });
};

//下载渲染全景图任务的sla指标信息
export const downoadRenderLogApi = async (storageFileId: string) => {
  return request(
    `/design/v1/decoration/getDownloadUrl/${storageFileId}`,
    {
      method: 'POST',
      params: {
        t: Date.now(),
      },
      data: { storageFileId },
    },
  );
};

export const getLogByTaskId = async (taskId: string) => {
  return request(`/transfer/v1/task/${taskId}/log`, {
    // tokenFree: true,
    method: 'POST',
    params: {
      t: Date.now(),
    },
  });
};

export const getRenderLogByTaskId = async (taskId: string) => {
  return request(`/design/v1/scene/render/task/${taskId}/log`, {
    // tokenFree: true,
    method: 'POST',
    params: {
      t: Date.now(),
      taskId
    },
  });
};

export const getTaskDetails = async (taskId: string) => {
  return request(`/transfer/v1/transferTask/${taskId}`, {
    // tokenFree: true,
    method: 'POST',
    params: {
      t: Date.now(),
    },
  });
};

export const getRenderTaskDetails = async (taskId: string) => {
  return request(`/design/v1/scene/render/task/${taskId}`, {
    // tokenFree: true,
    method: 'POST',
    params: {
      t: Date.now(),
    },
  });
};

// 下载
export async function getStorageFileUrl(fileId: string): Promise<any> {
  return request(`/transfer/v1/task/download/${fileId}`, {
    // tokenFree: true,
    method: 'POST',
  });
}

// 下载
export async function retryTransfer(taskId: string): Promise<any> {
  return request(`/transfer/v1/transferTask/retry/${taskId}`, {
    // tokenFree: true,
    method: 'POST',
  });
}

export async function getTenantList(): Promise<any> {
  return request(`/account/v1/activation-code/tenant/list`, {
    // tokenFree: true,
    method: 'POST',
  });
}

export async function createCode(
  codeNum: string | number | null,
  tenantId: string,
  extendData: string,
): Promise<any> {
  return request('/account/v1/activation-code/create', {
    // tokenFree: true,
    method: 'POST',
    data: {
      codeNum,
      tenantId,
      extendData,
    },
  });
}

export async function getCode(data: CodeParams): Promise<any> {
  return request('/account/v1/activation-code/page', {
    // tokenFree: true,
    method: 'POST',
    data: {
      ...data,
    },
  });
}

export async function doCode(activationCode: string, type: 'enable' | 'disable'): Promise<any> {
  return request(`/account/v1/activation-code/${activationCode}/${type}`, {
    // tokenFree: true,
    method: 'POST',
  });
}

export async function getUserInfo(userId: number): Promise<CurrentUser | any> {
  return request(`/account/v1/users/${userId}`, {
    method: 'GET',
  });
}

// 用户登出
export const userOut = async () => {
  return request('/account/v1/users/logout', {
    method: 'GET',
    messageFree: true,
  });
};

//获取当前用户BOSS权限点
export const getPermissionAction = async () => {
  return request('/account/v1/boss/permissionAction', {
    method: 'GET',
    messageFree: true,
  });
};

//获取mtbf
export const getMtbfs = async (params?: {
  from?: number;
  to?: number;
  page: number;
  pageSize: number;
  onlyCrash: boolean;
  objectType?: string;
  version?: string;
}) => {
  return request('/matchmaker/v1/mtbf/query', {
    method: 'GET',
    params: params,
  });
};

//查询最早记录时间
export const getEarliestTime = async () => {
  return request('/matchmaker/v1/mtbf/time/earliest', {
    method: 'GET',
  });
};

//sla统计 - fps 查询枚举值
export const getFpsEnum = async (params?: { type: string }) => {
  return request('/model/v1/ue/fps/biz/enum', {
    method: 'GET',
    params: params,
  });
};

//sla统计 - fps  查询fps
export async function getFps(data: getFpsParams): Promise<any> {
  return request('/model/v1/ue/fps:query', {
    method: 'POST',
    data: {
      ...data,
    },
  });
}
//sla统计 - fps  分页查询fps
export async function getFpsByPages(data: getFpsParams): Promise<any> {
  return request('/model/v1/ue/fps:page', {
    method: 'POST',
    data: {
      ...data,
    },
  });
}
//sla统计 - fps  分页查询fps
export async function getFpsStatistics(data: getFpsParams): Promise<any> {
  return request('/model/v1/ue/fps:statistics', {
    method: 'GET',
    params: data,
  });
}

//sla统计 - 打开  获取业务线
export const getOpenBizType = async () => {
  return request('/matchmaker/v1/open/sla/bizType', {
    method: 'GET',
  });
};
//sla统计 - 打开  获取终端类型
export const getOpenClientType = async () => {
  return request('/matchmaker/v1/open/sla/clientType', {
    method: 'GET',
  });
};
//sla统计 - 打开  获取文件类型
export const getOpenFileType = async () => {
  return request('/matchmaker/v1/open/sla/fileType', {
    method: 'GET',
  });
};

//获取打开文件的sla指标信
export async function getOpenSlaInfo(data: getOpenSlaParams): Promise<any> {
  return request('/matchmaker/v1/open/sla/info', {
    method: 'POST',
    data: {
      ...data,
    },
  });
}

// 获取打开文件的sla指标信息 - 不同时获取table数据的加速版
export async function getOpenSlaStatisticInfo(data: getOpenSlaParams): Promise<any> {
  return request('/matchmaker/v1/open/sla/statistics', {
    method: 'POST',
    data,
  });
}
// 获取打开文件的sla的table数据
export async function getOpenSlaTableInfo(data: getOpenSlaParams): Promise<any> {
  return request('/matchmaker/v1/open/sla/page', {
    method: 'POST',
    data: {
      ...data,
    },
  });
}

// 统计渲染全景图的sla指标信息
export async function getRenderStatisticInfo(data: any): Promise<any> {
  return request('/design/v1/renderTask/sla/statistics', {
    method: 'POST',
    data,
  });
}

// 分页查询渲染任务列表
export async function getRenderTableInfo(data: any): Promise<any> {
  return request('/design/v1/renderTask/sla/page', {
    method: 'POST',
    data: {
      ...data,
    },
  });
}

//下载渲染全景图任务的sla指标信息
export const downoadRenderApi = async (params: any) => {
  return request(
    '/design/v1/renderTask/sla/download',
    {
      method: 'POST',
      params: {
        t: Date.now(),
      },
      data: params,
    },
    true,
  );
};

//下载  fps
export const downoadAllApi = async (params: any) => {
  return request('/model/v1/ue/fps/sla/download', {
    method: 'POST',
    params: {
      t: Date.now(),
    },
    data: params,
  });
};

//下载  sla - 打开
export const downoadOpenApi = async (params: any) => {
  return request(
    '/matchmaker/v1/open/sla/download',
    {
      method: 'POST',
      params: {
        t: Date.now(),
      },
      data: params,
    },
    true,
  );
};

export async function getUploadUrl(url: string, params: UploadUrlParams) {
  return request(url, {
    method: 'POST',
    // tokenFree: true,
    data: params,
  });
}

//正向mtbf统计之获取 版本
export const getVersions = async () => {
  return request('/matchmaker/v1/mtbf/versions', {
    method: 'GET',
  });
};

/**
 * f文件地址
 * @param params
 * @returns promise
 */
export async function getPresignedUrl(params: {
  fileId: string;
  fileName?: string;
  /*
   *解决dwg预览乱码问题，有这个标识，后端不添加attachment
   */
  ignoreAttachment?: boolean;
}): Promise<any> {
  return request(`/storage/v1/objects/${params.fileId}/download/presigned`, {
    method: 'POST',
    messageFree: true,
    data: {
      appName: 'web',
      fileName: params.fileName,
      ignoreAttachment: params?.ignoreAttachment,
    },
  });
}

//获取导出任务列表，分页
export async function getExportTaskApi(params: { page: number; pageSize: number }): Promise<any> {
  return request(`/boss/api/v1/export/task/search`, {
    method: 'GET',
    params,
  });
}

//导出任务下载
export async function getExportTaskUrl(id: string): Promise<any> {
  return request(`/boss/api/v1/export/task/${id}`, {
    method: 'GET',
  });
}
